<template>
  <div class="flex flex-col w-screen h-screen bg-white">
    <div class="flex w-full h-full">
      <ClientOnly>
        <DrawerSidebarLeft class="h-full flex-shrink-0 overflow-hidden" />
      </ClientOnly>

      <div class="flex-grow h-full custom-scroll overflow-auto">
        <slot />
      </div>

      <ClientOnly>
        <UtilsShowOnAuth>
          <DrawerSidebarRight class="h-full flex-shrink-0 overflow-hidden" />
        </UtilsShowOnAuth>
      </ClientOnly>
    </div>
  </div>
  <AppAdminToggle />
</template>

<style>
.custom-scroll::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.custom-scroll {
  scrollbar-width: none;
}
</style>
